const initialState = {
    users: {},
    loading: false

};
export default initialState;